import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Info } from 'lucide-react';
import { Habit, loadHabits, saveHabits } from '../utils/storage';
export const AddHabit: React.FC = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [identity, setIdentity] = useState('');
  const [cue, setCue] = useState('');
  const isAmbitious = name.toLowerCase().includes('minutes') || name.toLowerCase().includes('hour') || name.match(/\d{2,}/); // Contains large numbers
  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !identity.trim()) return;
    const newHabit: Habit = {
      id: crypto.randomUUID(),
      name: name.trim(),
      identity: identity.trim(),
      cue: cue.trim(),
      frequency: 'daily',
      createdAt: new Date().toISOString(),
      completions: []
    };
    const habits = loadHabits();
    saveHabits([...habits, newHabit]);
    navigate('/');
  };
  return <div className="pb-24 pt-8 px-6 max-w-md mx-auto min-h-screen bg-white" data-id="element-54">
      <header className="mb-8 flex items-center" data-id="element-55">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 mr-2 text-gray-400 hover:text-gray-900 transition-colors" data-id="element-56">
          <ArrowLeft size={24} data-id="element-57" />
        </button>
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-58">New Habit</h1>
      </header>

      <form onSubmit={handleSave} className="space-y-6" data-id="element-59">
        <div data-id="element-60">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-61">
            Identity (Who are you becoming?)
          </label>
          <input type="text" value={identity} onChange={e => setIdentity(e.target.value)} placeholder="e.g. a reader, a runner, a writer" className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#6B8F71] focus:border-transparent outline-none transition-all" required data-id="element-62" />
        </div>

        <div data-id="element-63">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-64">
            Habit (What is the 2-minute version?)
          </label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Read 1 page, Tie running shoes" className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#6B8F71] focus:border-transparent outline-none transition-all" required data-id="element-65" />

          {isAmbitious && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} className="mt-3 flex items-start space-x-2 text-sm text-amber-600 bg-amber-50 p-3 rounded-lg" data-id="element-66">
              <Info size={16} className="mt-0.5 flex-shrink-0" data-id="element-67" />
              <p data-id="element-68">
                This looks a bit ambitious. To build consistency, try scaling it
                down to a 2-minute version (e.g., "Read 1 page" instead of "Read
                30 mins").
              </p>
            </motion.div>}
        </div>

        <div data-id="element-69">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-70">
            Cue (When will you do it?){' '}
            <span className="text-gray-400 font-normal" data-id="element-71">Optional</span>
          </label>
          <input type="text" value={cue} onChange={e => setCue(e.target.value)} placeholder="e.g. After pouring my morning coffee" className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#6B8F71] focus:border-transparent outline-none transition-all" data-id="element-72" />
        </div>

        <div className="pt-6" data-id="element-73">
          <button type="submit" disabled={!name.trim() || !identity.trim()} className="w-full bg-gray-900 text-white p-4 rounded-xl font-medium hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-74">
            Create Habit
          </button>
        </div>
      </form>
    </div>;
};